import { FC, ReactNode } from 'react'
import { SpaceProps } from 'styled-system'
import { StyledGrid } from './Grid.style'

export interface IGrid extends SpaceProps {
  children?: ReactNode
  fullHeight?: boolean
}

const Grid: FC<IGrid> = ({ children, fullHeight, ...rest }) => {
  return (
    <StyledGrid fullHeight={fullHeight} {...rest}>
      {children}
    </StyledGrid>
  )
}

export default Grid
